import styled from 'styled-components/macro';
import { mobileHeaderHeight, tabletHeaderHeight } from '../LayoutStyles';

export const DeviceHeaderDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${props => props.theme.white};
  height: ${mobileHeaderHeight};
  ${props => props.theme.bottomDropShadow};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 768px) {
    height: ${tabletHeaderHeight};
  }
`;

export const LogoImg = styled.img`
  position: absolute;

  height: 28px;
  left: 20px;
  @media screen and (min-width: 768px) {
    left: 25px;
    height: 24px;
  }
`;

export const MenuIconDiv = styled.div`
  position: absolute;
  right: 20px;
  @media screen and (min-width: 768px) {
    right: 25px;
  }
  svg {
    height: 2.8rem;
    width: 2.8rem;
  }
`;
